import { ErrorHandler, inject, NgModule, provideAppInitializer } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';

@NgModule({
    providers: [
        {
            provide: ErrorHandler,
            useValue: Sentry.createErrorHandler({
                showDialog: false
            })
        },
        {
            provide: Sentry.TraceService,
            deps: [ Router ]
        },
        provideAppInitializer(() => {
            inject(Sentry.TraceService);
        })
    ]
})
export class AppSentryModule {
}
